import "./frontend.scss";
import "swiper/swiper-bundle.css";

// import './vue/vue-router'
import "./vue/filter";
import Router from "./util/Router";

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */

import common from "./routes/common";
import home from "./routes/home";
import about from "./routes/about";
import contactUs from "./routes/contact";
import faq from "./routes/faq";
import buyProperty from "./routes/buy-property";
import postProperty from "./routes/post-property";
import postTypeArchiveProperty from "./routes/post-type-archive-property";
import singleProperty from "./routes/property";

const routes = new Router({
  common,
  home,
  about,
  contactUs,
  faq,
  buyProperty,
  postProperty,
  postTypeArchiveProperty,
  singleProperty,
});

window.addEventListener("DOMContentLoaded", () => {
  routes.loadEvents();
});
